import React from 'react';
import { Card, Grid, Typography } from '@mui/material';

const CardStyle = {
  position: 'relative',
  borderRadius: 12,
  boxShadow: 'var(--my-shadow)',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
};

const ColoredTopBorderCard = props => {
  const { color, background, contentStyle, children, style, title, action } = props;

  return (
    <Card style={{ ...CardStyle, background: background, ...style }}>
      {/* 頂部色條 */}
      <Grid
        container
        wrap="nowrap"
        sx={{
          background: color,
          padding: '4px 12px',
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: 32
        }}
      >
        {title && (
          <Grid>
            <Typography
              style={{
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '1.4rem',
                lineHeight: 1.2,
                letterSpacing: '0.05em'
              }}
            >
              {title}
            </Typography>
          </Grid>
        )}
        {action && (
          <Grid>
            {action}
          </Grid>
        )}
      </Grid>

      {/* 內容區 */}
      <Grid style={{ padding: '8px 16px', ...contentStyle }}>{children}</Grid>
    </Card>
  );
};

export default ColoredTopBorderCard;
